import apiClient from '../util/apiClient'

const client = apiClient(process.env.REACT_APP_SSO_API_URL)

export default client
